import { PageDataServiceFactory } from 'app/_services/CMS'
import { useEffect, useState } from 'react'
import { IProductEntry } from 'app/_services/CMS/contentful/types/productEntry'

export function useProductCategory({
  productSlug,
  fetch,
}: {
  productSlug: string
  fetch: boolean
}) {
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string>(null)
  const [productCategory, setProductCategory] = useState<IProductEntry>(null)

  useEffect(() => {
    const loadProductCategory = async (slug) => {
      setLoading(true)

      if (!slug) {
        return null
      }

      try {
        const pageDataService = PageDataServiceFactory.createService()
        const productCategory: IProductEntry =
          await pageDataService.getProductEntries({
            productSlug: slug,
            urlSlug: null,
          })

        setProductCategory(productCategory)
      } catch (err) {
        setError(err.message || 'Failed to fetch product category.')
      } finally {
        setLoading(false)
      }
    }

    if (fetch) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      loadProductCategory(productSlug)
    }
  }, [fetch, productSlug])

  return {
    loading,
    error,
    productCategory,
  }
}
